/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getNotificationsList: (params) => {
    return axios.get(API_ENDPOINTS.GET_NOTIFICATIONS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getUsersList: (params) => {
    return axios.get(API_ENDPOINTS.GET_USERS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  sendsmsnotifications: (data) => {
    return axios.post(API_ENDPOINTS.SEND_SMS_NOTIFICATIONS, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", },
      data
    });
  },
  sendmailnotifications: (data) => {
    return axios.post(API_ENDPOINTS.SEND_MAIL_NOTIFICATIONS, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", },
      data
    });
  },
  sendpushnotifications: (data) => {
    return axios.post(API_ENDPOINTS.SEND_PUSH_NOTIFICATIONS, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", },
      data
    });
  },
  deleteMultipleNotifications: ({ ids }) => {
    return axios.delete(API_ENDPOINTS.DELETE_MULTIPLE_NOTIFICATIONS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      data: { ids },
    });
  },
};
